import { RouteObject } from "react-router-dom";
import SistemaView from "./Sistema/Sistema.View";
import SistemaCadastroView from "./Sistema/Cadastro/SistemaCadastro.View";
import UsuarioCadastroView from "./Usuario/Cadastro/UsuarioCadastro.View";
import UsuarioView from "./Usuario/Usuario.View";

export const ConfiguracoesRoutes: RouteObject[] = [
  {
    path: "configuracao/sistema",
    element: <SistemaView />,
  },
  {
    path: "configuracao/sistema/cadastro",
    element: <SistemaCadastroView />,
  },
  {
    path: "usuario",
    element: <UsuarioView />,
  },
  {
    path: "usuario/cadastro",
    element: <UsuarioCadastroView />,
  },
];
